'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  andUp: '& Up'
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/widgets/star-rating/defaultLabels.js